import { MenuItem, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { Controller, Control } from 'react-hook-form';

export interface DropdownOption {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  label: string;
}

interface DropdownProps {
  name: string;
  control: Control;
  label: string;
  options: DropdownOption[];
  textFieldProps?: TextFieldProps;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorColor?: string;
  onSelectOption?: (option: DropdownOption) => void;
}

export default function Dropdown({
  name,
  control,
  label,
  options,
  textFieldProps,
  required,
  disabled,
  error,
  errorColor,
  onSelectOption,
}: DropdownProps) {
  const generateSingleOptions = () => options.map((option) => (
    <MenuItem key={option.value} value={option.value}>
      {option.label}
    </MenuItem>
  ));

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <TextField
          fullWidth
          label={label}
          onChange={(e) => {
            onChange(e);
            if (onSelectOption) {
              const selected = options.find((opt) => opt.value === e.target.value);
              if (selected) onSelectOption(selected);
            }
          }}
          select
          value={value}
          variant='outlined'
          required={required}
          disabled={disabled}
          error={error}
          sx={
            error
              ? {
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: errorColor,
                  },
                  '&:hover fieldset': {
                    borderColor: errorColor,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: errorColor,
                  },
                },
                '& .MuiInputLabel-root': {
                  color: errorColor,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: errorColor,
                },
              }
              : {}
          }
          {...textFieldProps}
        >
          {generateSingleOptions()}
        </TextField>
      )}
    />
  );
}
